var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-vimeo-container"},[_c('iframe',{staticClass:"player-vimeo",attrs:{"src":_vm.videoLink,"title":"Video","allow":"autoplay; fullscreen; picture-in-picture","allowfullscreen":"","loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }